<template>
	<div class="root-wrap fx-column">
		<div class="body-wrap fx-fill">
			<div class="fill-box">
				<van-list
					v-model="listLoading"
					:finished="listFinished"
					finished-text="- 我也是有底线的 -"
					@load="onLoad"
					:immediate-check="false"
				>
					<movie-scroll
						:list="movieList"
						@buy="buyTicket"
						@detail="goDetail"
					></movie-scroll>
				</van-list>
			</div>
		</div>
	</div>
</template>

<script>
import MovieScroll from "@/components/movie/movie-scroll";
import { mapGetters } from "vuex";
import { movieNow, movieSoon } from "@/utils/api.js";
export default {
	computed: {
		...mapGetters([
			"position",
			"currentCityCode",
			"currentCityName",
			"currentCountyCode",
			"currentCountyName",
			"currentCityId",
		]),
		selectedLocation() {
			return this.$store.state.app.selectedLocation;
		},
	},
	data() {
		return {
			enterType: this.$route.query.type == 1 ? 1 : 2,
			movieList: [],
			listLoading: false,
			listFinished: false,
			page: {
				pageSize: 10,
				current: 0,
			},
		};
	},
	mounted() {
		if (this.enterType == 1) {
			this.getHotMovieList();
		} else {
			this.getFutureMovieList("即将上映");
		}
	},
	methods: {
		onLoad() {
			if (this.listFinished) return;
			if (this.enterType == 1) {
				this.getHotMovieList();
			} else {
				this.getFutureMovieList("即将上映");
			}
		},
		buyTicket(movieId, movieName) {
			this.$goPage("cinema", {
				movieId,
				movieName: movieName,
			});
		},
		goDetail(movieId) {
			this.$goPage("movie-detail2", {
				movieId,
			});
		},
		async getHotMovieList() {
			if (this.listFinished) return;
			this.listLoading = true;
			this.page.current++;
			let params = {
				cityId: this.currentCityId,
				pageIdx: this.page.current,
				pageSize: this.page.pageSize,
			};
			const res2 = await movieNow(params);
			this.movieList = [...this.movieList, ...res2.data];
			let nowTime = new Date().getTime();
			this.movieList.forEach((item) => {
				item.publish_date = item.publish_date.replaceAll("-", "/");
				if (new Date(item.publish_date).getTime() < nowTime) {
					item.isBuy = true;
				}
			});
			this.listLoading = false;
			if (this.movieList.length >= res2.total) {
				this.listFinished = true;
			}
		},
		async getFutureMovieList() {
			if (this.listFinished) return;
			this.listLoading = true;
			this.page.current++;
			let params = {
				cityId: this.currentCityId,
				pageIdx: this.page.current,
				pageSize: this.page.pageSize,
			};
			const res = await movieSoon(params);
			this.movieList = [...this.movieList, ...res.data];
			this.listLoading = false;
			if (this.movieList.length >= res.total) {
				this.listFinished = true;
			}
		},
	},
	components: {
		MovieScroll,
	},
};
</script>

<style lang="scss">
.body-wrap {
	position: relative;
}
</style>
